import UserFilterView from '@UI/Pages/Administration/Users/Filters/UserFilterView';
import { createSignal } from '@verclam/pulsar';

const userFiltersSignal = createSignal<UserFilterView>(UserFilterView.createDefault());

export const setUserFilters = (filters: UserFilterView): void => {
	userFiltersSignal.value = filters;
};

export default userFiltersSignal;
